import store from '../../store'
import find from 'lodash/find'
import {updateMeetingTimesRequest} from '../../actions/meetings'

export function updateMeetingTimes(meetingId,meetingDate,startTime,endTime) {	
	store.dispatch(updateMeetingTimesRequest(meetingId,meetingDate,startTime,endTime))
	
}

